import React, { useState, useEffect } from 'react';
import { Button, Typography, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import PolicyPageLayout from './PolicyPageLayout';
import ajaxService from '../../services/ajax-service';

const { Text } = Typography;

const PAGE_TYPE = 'privacy';

const PrivacyPolicy = () => {
    const routerHistory = useHistory();
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError(null);
        ajaxService.getPageByType(PAGE_TYPE)
            .then((res) => {
                if (cancelled) return;
                if (res && res.success && res.data) {
                    setPage(res.data);
                } else {
                    setPage(null);
                }
            })
            .catch(() => {
                if (!cancelled) setError(true);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => { cancelled = true; };
    }, []);

    const title = page?.title ?? 'Privacy Policy';
    const description = page?.description ?? 'We respect your privacy. This policy describes how we collect, use, and protect your personal information.';

    return (
        <PolicyPageLayout>
            {loading ? (
                <div style={{
                    textAlign: 'center',
                    padding: '64px 24px',
                    minHeight: 220,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 20,
                }}>
                    <Spin size="large" style={{ color: 'var(--primary-purple)' }} />
                    <Text style={{ color: 'var(--text-gray)', fontSize: '0.9rem', fontWeight: 500 }}>Loading...</Text>
                </div>
            ) : (
                <>
                    <div style={{
                        textAlign: 'center',
                        marginBottom: 24,
                        paddingBottom: 20,
                        borderBottom: '2px solid rgba(254, 2, 125, 0.18)',
                    }}>
                        <h2 style={{
                            margin: 0,
                            fontWeight: 700,
                            fontSize: '1.5rem',
                            letterSpacing: '0.02em',
                            lineHeight: 1.3,
                            background: 'var(--gradient-primary)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text',
                        }}>
                            {title}
                        </h2>
                    </div>
                    <div
                        className="policy-content policy-content-html"
                        style={{
                            color: 'var(--text-gray)',
                            fontSize: '0.9rem',
                            lineHeight: 1.8,
                            marginBottom: 28,
                            maxHeight: 440,
                            overflowY: 'auto',
                            padding: '20px 22px',
                            background: 'rgba(255, 255, 255, 0.7)',
                            borderRadius: 16,
                            border: '1px solid rgba(254, 2, 125, 0.1)',
                            borderLeft: '4px solid var(--primary-purple)',
                            wordBreak: 'break-word',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                        }}
                    >
                        {error ? (
                            <Text style={{ color: 'var(--text-gray)', fontSize: '0.875rem' }}>
                                Unable to load content. Please try again later.
                            </Text>
                        ) : typeof description === 'string' && description.trim().startsWith('<') ? (
                            <div dangerouslySetInnerHTML={{ __html: description }} />
                        ) : (
                            <Text style={{ color: 'var(--text-gray)', fontSize: '0.875rem' }}>{description}</Text>
                        )}
                    </div>
                </>
            )}
            <div style={{ textAlign: 'center', marginTop: 8 }}>
            <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => routerHistory.push('/login')}
                size="middle"
                style={{
                    height: 40,
                    paddingLeft: 20,
                    paddingRight: 20,
                    borderRadius: 10,
                    background: 'var(--gradient-primary)',
                    border: 'none',
                    color: '#fff',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                    boxShadow: '0 2px 12px rgba(254, 2, 125, 0.25)',
                    transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-1px)';
                    e.currentTarget.style.boxShadow = '0 4px 16px rgba(254, 2, 125, 0.35)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 2px 12px rgba(254, 2, 125, 0.25)';
                }}
            >
                Back to Login
            </Button>
            </div>
        </PolicyPageLayout>
    );
};

export default PrivacyPolicy;
